(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-width-clickable-image-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hg-clickable-slideshow')) {
    customElements.define('hg-clickable-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.events?.abort();
        this.observer?.disconnect();
        this.initialized = false;
      }

      init() {
        if (this.initialized || !this.isConnected) return;
        this.initialized = true;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        if (!this.slides.length) return;

        this.index = 0;
        this.events = new AbortController();
        const on = (target, name, callback, options = {}) => {
          target.addEventListener(name, callback, { ...options, signal: this.events.signal });
        };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.autoplay = this.dataset.autoplay === 'true';
        this.editor = this.dataset.designMode === 'true';
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.gesture = null;
        this.suppressClickUntil = 0;
        this.playButton = this.querySelector('[data-toggle]');
        this.status = this.querySelector('[data-status]');
        this.viewport = this.querySelector('.cis__viewport');
        const controls = this.querySelector('[data-controls]');
        if (controls) controls.hidden = this.slides.length < 2;

        on(this, 'click', (event) => {
          if (!(event.target instanceof Element)) return;
          if (event.target.closest('[data-prev]')) this.go(this.index - 1, true);
          if (event.target.closest('[data-next]')) this.go(this.index + 1, true);
          const dot = event.target.closest('[data-dot]');
          if (dot) this.go(Number(dot.dataset.dot), true);
          if (event.target.closest('[data-toggle]')) {
            this.paused = !this.paused;
            this.updatePlayback();
          }
        });
        on(this.viewport, 'click', (event) => {
          if (event.detail !== 0 && Date.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { capture: true });

        on(this, 'keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
          this.go(next, true);
        });
        on(this, 'pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        });
        on(this, 'pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.schedule();
        });
        on(this, 'focusin', () => { this.focused = true; this.schedule(); });
        on(this, 'focusout', (event) => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        });
        on(document, 'visibilitychange', () => this.schedule());
        on(this.motion, 'change', (event) => {
          if (event.matches) this.paused = true;
          this.updatePlayback();
        });

        on(this.viewport, 'pointerdown', (event) => {
          if (!event.isPrimary || event.pointerType === 'mouse' || this.slides.length < 2) return;
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          this.suppressClickUntil = 0;
          this.schedule();
        }, { passive: true });
        on(window, 'pointerup', (event) => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          const dx = event.clientX - this.gesture.x;
          const dy = event.clientY - this.gesture.y;
          this.gesture = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) {
            this.suppressClickUntil = Date.now() + 500;
            this.go(this.index + (dx < 0 ? 1 : -1), true);
          } else {
            this.schedule();
          }
        }, { passive: true });
        on(window, 'pointercancel', (event) => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          this.gesture = null;
          this.schedule();
        });

        on(this, 'shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === String(event.detail.blockId));
          if (index < 0) return;
          this.go(index);
        });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            this.schedule();
          });
          this.observer.observe(this);
        }
        this.go(0);
        this.updatePlayback();
      }

      go(index, announce = false) {
        const next = (index + this.slides.length) % this.slides.length;
        const focusedSlide = this.slides.find(slide => slide.contains(document.activeElement));
        this.index = next;
        this.slides.forEach((slide, position) => {
          const active = position === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
          const link = slide.querySelector('a');
          if (link) link.tabIndex = active ? 0 : -1;
          if (active) {
            const image = slide.querySelector('img');
            if (image) image.loading = 'eager';
          }
        });
        this.dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === this.index)));
        if (focusedSlide && focusedSlide !== this.slides[this.index]) {
          const activeSlide = this.slides[this.index];
          activeSlide.tabIndex = -1;
          (activeSlide.querySelector('a') || activeSlide).focus({ preventScroll: true });
        }
        if (announce && this.status) this.status.textContent = 'Slide ' + (this.index + 1) + ' of ' + this.slides.length;
        const nextImage = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
        if (nextImage) nextImage.loading = 'eager';
        this.schedule();
      }

      updatePlayback() {
        if (this.playButton) {
          this.playButton.hidden = this.editor;
          this.playButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
          this.playButton.querySelector('[data-play-icon]').hidden = !this.paused;
          this.playButton.querySelector('[data-pause-icon]').hidden = this.paused;
        }
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.autoplay || this.editor || this.paused || this.hovered || this.focused || this.gesture || !this.visible || document.hidden || this.slides.length < 2) return;
        this.timer = setTimeout(() => this.go(this.index + 1), Math.max(2000, Number(this.dataset.interval) || 5000));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
